
import { combineReducers, } from 'redux';
//import authReducer from "./reducers/slices/authSlice";
//import authReducer from "./slices/authSlice";
// import auth, { AuthState } from './reducers/slices/authSlice';
// import paymentHistoryReducer, { PaymentState } from './reducers/slices/paymentHistorySlice';
// import cartReducer, { CartState, } from "./reducers/slices/cartSlice";
// import vendorReducer from "./reducers/slices/vendorSlice";

interface RootState {
  // auth: AuthState;
  // cart: CartState;
  // paymentHistory: PaymentState;
}

const rootReducer = combineReducers({
  // auth: authReducer,
  // cart: cartReducer,
  // paymentHistory: paymentHistoryReducer,
  // vendor: vendorReducer,
  //auth
});

export default rootReducer;
export type { RootState };
